import { CreateDimensionError } from "./CreateDimensionError";

export default class DimensionRecordAlreadyExistsError extends CreateDimensionError {

}